export type ScopedProjectComment = {
  id: string;
  fileId?: string;
  trackIndex?: number;
  replyTo?: string;
};

function includeReplies<T extends ScopedProjectComment>(
  comments: T[],
  topLevel: T[],
): T[] {
  const includedIds = new Set(topLevel.map((comment) => comment.id));
  let changed = true;

  while (changed) {
    changed = false;
    for (const comment of comments) {
      if (
        comment.replyTo &&
        includedIds.has(comment.replyTo) &&
        !includedIds.has(comment.id)
      ) {
        includedIds.add(comment.id);
        changed = true;
      }
    }
  }

  return comments.filter((comment) => includedIds.has(comment.id));
}

export function commentsForTrack<T extends ScopedProjectComment>(
  comments: T[],
  trackIndex: number,
): T[] {
  const topLevel = comments.filter(
    (comment) => !comment.replyTo && comment.trackIndex === trackIndex,
  );
  return includeReplies(comments, topLevel);
}

export function commentsForReviewFile<T extends ScopedProjectComment>(
  comments: T[],
  fileId: string | undefined,
  trackIndex?: number,
): T[] {
  const topLevel = comments.filter((comment) => {
    if (comment.replyTo) return false;
    if (comment.fileId) return comment.fileId === fileId;
    if (trackIndex !== undefined) return comment.trackIndex === trackIndex;
    return comment.trackIndex === undefined && !comment.fileId;
  });
  return includeReplies(comments, topLevel);
}
